/**
 * Field Note Status
 */
enum FieldNoteStatus {

   		/// <summary>
		/// The field note has not been reviewed by OA Staff
		/// </summary>
		Pending = 0,

		/// <summary>
		/// The field note has been reviewed by OA Staff and approved for public visibility
		/// </summary>
		Approved = 1,

		/// <summary>
		/// The field note has been reviewed by OA Staff and NOT approved for public visibility
		/// </summary>
		Disapproved = 2
}

export default FieldNoteStatus;